var map = {
	"./allianceHall.png": 8542,
	"./backgroundImage.png": 537,
	"./benefit.png": 6995,
	"./capital.png": 1806,
	"./city.png": 969,
	"./deadSpace.png": 3830,
	"./eliteMine.png": 7866,
	"./farm.png": 6900,
	"./flag-FAK.png": 8623,
	"./flag-PHX.png": 3905,
	"./flag.png": 7546,
	"./fort.png": 6267,
	"./institute.png": 6727,
	"./lab.png": 4899,
	"./mechanicShop.png": 6406,
	"./megaCity.png": 6011,
	"./militaryArea.png": 3766,
	"./powerOre.png": 5233,
	"./ruins.png": 6739,
	"./sandBag.png": 5254,
	"./warFactory.png": 9944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;